import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Loader2, ArrowRight } from "lucide-react";

const LOGO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_cycle-power-2/artifacts/zp1guu9j_logo_new.png";

export default function AdminLogin() {
  const { user, login, error } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [logoUrl, setLogoUrl] = useState(LOGO);

  useEffect(() => {
    api.get("/public/settings").then((r) => { const L = r.data?.logo_light || r.data?.logo; if (L) setLogoUrl(L); }).catch(() => {});
  }, []);

  useEffect(() => {
    if (user && user.id) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) navigate("/admin", { replace: true });
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:flex flex-col justify-between bg-[#0F172A] text-white p-12">
        <img src={logoUrl} alt="#ShowUsYourMoves" className="h-11 w-auto object-contain self-start" />
        <div>
          <p className="eyebrow" style={{ color: "#CAE295" }}>Content Studio</p>
          <h1 className="mt-4 font-display font-black uppercase text-5xl leading-[0.95]">
            Run the <span className="italic text-[#2CACD4]">movement.</span>
          </h1>
          <p className="mt-4 text-white/60 max-w-sm">Manage every event, book and story that powers #ShowUsYourMoves.</p>
        </div>
        <p className="text-white/40 text-sm">National Health & Fitness Foundation</p>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <img src={logoUrl} alt="#ShowUsYourMoves" className="h-10 w-auto lg:hidden mb-8" />
          <h2 className="font-display font-black uppercase text-3xl">Admin sign in</h2>
          <p className="mt-2 text-muted-foreground text-sm">Sign in to manage site content.</p>

          <label className="mt-8 block text-sm font-semibold">Email</label>
          <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required autoComplete="username"
            className="mt-1.5 w-full rounded-2xl border border-border bg-card px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#2CACD4]" data-testid="admin-login-email" />

          <label className="mt-4 block text-sm font-semibold">Password</label>
          <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required autoComplete="current-password"
            className="mt-1.5 w-full rounded-2xl border border-border bg-card px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#2CACD4]" data-testid="admin-login-password" />

          {error && <p className="mt-4 text-sm text-[#DB1A5C]" data-testid="admin-login-error">{error}</p>}

          <button type="submit" disabled={busy}
            className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#0F172A] text-white hover:bg-[#2CACD4] hover:text-slate-950 font-bold px-6 py-3.5 transition-colors cursor-pointer disabled:opacity-60"
            data-testid="admin-login-submit">
            {busy ? <Loader2 className="animate-spin" size={18} /> : <>Sign in <ArrowRight size={18} /></>}
          </button>
        </form>
      </div>
    </div>
  );
}
